import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["shadowField"]

  connect() {
    this.submitting = false
  }

  clickShadowField(event) {
    const field = this.shadowFieldTarget
    if (!field) return

    field.click()
    this.submitForm(field)
  }

  submitForm(field) {
    if (this.submitting) return
    const form = field.form
    if (!form) return

    this.submitting = true
    form.requestSubmit()
  }
}

